<div class="row">
  <div class="col-10">
    <h3 mat-dialog-title>{{ 'ChangeEmail' | translate }}</h3>
  </div>
  <div class="col-2 p-0">
    <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()">
      <fa-icon [icon]="faTimesCircle"></fa-icon>
      
    </button>
  </div>
</div>


<mat-dialog-content class="change-pass-modal">
  <div class="row change-password">
    <div class="col-md-12">

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <p>{{ 'PleaseDefineYourNewEmailAddressAndConfirmIt' | translate }}.</p>
        <div class="form-group row">
          <label class="col-12">{{ 'NewEmailAddress' | translate }}</label>
          <div class="col-md-12">
            <input   type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            <div class="required">
              <!-- <div *ngIf="f.email.errors&&f.email.errors.email!=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}
                </div>
              </div> -->
              <div *ngIf="f.email.errors && f.email.errors.UserAlreadyExist !=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'EmailAlreadyExist' | translate }}
                </div>
              </div>
            </div>
            <div *ngIf="submitted && f.email.errors?.pattern">
              <div class="validation-error">
                <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}
              </div>
            </div>
            <div *ngIf="submitted && f.email.errors" class="required">
              <div *ngIf="f.email.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
            </div>
            
            
          </div>
        </div>
        <div class="form-group mb-0 mt-4">
          <button class="btn default-btn mr-2"  mat-button>{{ 'Confirm' | translate }}</button>
          <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
        </div>
       
    </form>





    </div>
  </div>
</mat-dialog-content>
